module.exports = __webpack_public_path__ + "static/media/wp1.44a936a1.jpg";